export const INITIAL_STATE_MOVIMENT_PESTICIDES = {
  id: "",
  idVenda: "",
  idCompra: "",
  refId: "",
  idAgrotoxico: "",
  idEmbalagem: "",
  embalagem: "",
  lote: "",
  idFornecedor: "",
  idResponsavel: "",
  naturezaOperacao: "",
  quantidade: "",
  data: "",
  dataVencimento: "",
  dataNfe: "",
  destinoProduto: "Dentro Estado",
  observacao: "",
  tipo: "",
  numeroNfe: "",
  serieNfe: "",
  createdAt: "",
  updatedAt: "",
}

export const INVALID_FIELDS_MOVIMENT_PESTICIDES = {
  idResponsavel: "",
  idFornecedor: "",
  naturezaOperacao: "",
  quantidade: "",
  idAgrotoxico: "",
  idEmbalagem: "",
  embalagem: "",
  lote: "",
  data: "",
  dataNfe: "",
  destinoProduto: "",
  tipo: "",
  numeroNfe: "",
  serieNfe: "",
}